import Status from "../ValueObject/Status";
import DownloadType from "../ValueObject/DownloadType";

export default class DownloadManager {
    public constructor(
        private readonly id: number,
        private readonly name: string,
        private readonly type: DownloadType,
        private readonly status: Status,
    ) {
    }

    public getId(): number {
        return this.id;
    }

    public getName(): string {
        return this.name;
    }

    public getType(): DownloadType {
        return this.type;
    }

    public getStatus(): Status {
        return this.status;
    }
}